import { Duration as DurationWithMinMax } from '@reward-platform/ancillaries-schemas/common'
import { compareMinMaxDuration, Duration, minutesToDuration } from '~/utils/datetime'
import useIntl from '../useIntl/useIntl'

export const useDateMessageFormatters = () => {
  const intl = useIntl()
  const formatDays = (count?: number) =>
    Boolean(count) &&
    intl.formatMessage(
      { id: 'days', defaultMessage: `{count} {count, plural, one {day} other {days}}` },
      { count }
    )
  const formatHours = (count?: number) =>
    Boolean(count) &&
    intl.formatMessage(
      { id: 'hours', defaultMessage: `{count} {count, plural, one {hour} other {hours}}` },
      { count }
    )
  const formatMinutes = (count?: number) =>
    Boolean(count) &&
    intl.formatMessage(
      { id: 'minutes', defaultMessage: `{count} {count, plural, one {minute} other {minutes}}` },
      { count }
    )

  const formatTime = (dateTime: string) =>
    intl.formatTime(dateTime, {
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23',
    })

  const formatDuration = (duration: Duration) =>
    [formatDays(duration.days), formatHours(duration.hours), formatMinutes(duration.minutes)]
      .filter((v) => v)
      .join(', ')

  const formatDurationWithMinMax = (duration: DurationWithMinMax) => {
    if (duration?.minDuration !== undefined && duration.maxDuration !== undefined) {
      const minDurationObject = minutesToDuration(duration.minDuration)
      const maxDurationObject = minutesToDuration(duration.maxDuration)

      const minValue = compareMinMaxDuration(minDurationObject, maxDurationObject)
      const minDuration =
        typeof minValue === 'number' ? minValue : formatDuration(minDurationObject)
      return `${minDuration} to ${formatDuration(maxDurationObject)}`
    }
    if (duration?.duration) {
      return formatDuration(minutesToDuration(duration.duration))
    }
    return duration?.freeText
  }

  return {
    formatDays,
    formatHours,
    formatMinutes,
    formatTime,
    formatDuration,
    formatDurationWithMinMax,
  }
}
